<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 17:54:40
-->
<template>
    <div class="add-danwei">
        <el-form ref="ruleForm" :model="viewData" label-width="100px">
            <el-form-item label="车牌号" prop="first_word">
                {{ viewData.car_number }}
            </el-form-item>
            <el-form-item label="车辆图片" prop="">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="$adddom(viewData.car_pic)"
                    :preview-src-list="[$adddom(viewData.car_pic)]"
                >
                </el-image>
            </el-form-item>
            <el-form-item label="所有者" prop="">
                {{ viewData.user && viewData.user.nickname }}
            </el-form-item>
            <el-form-item label="所有者图片" prop="">
                <el-image
                    v-if="viewData.user"
                    style="width: 100px; height: 100px"
                    :src="$adddom(viewData.user.avatar)"
                    :preview-src-list="[$adddom(viewData.user.avatar)]"
                >
                </el-image>
            </el-form-item>
            <el-form-item label="所有者电话" prop="">
                {{ viewData.user && viewData.user.phone }}
            </el-form-item>
            <el-form-item label="所属小区" prop="">
                {{ viewData.user_resource && viewData.user_resource.commName }}
            </el-form-item>
            <el-form-item label="所属资源" prop="">
                {{
                    viewData.user_resource &&
                    viewData.user_resource.resourceCode
                }}
            </el-form-item>
            <el-form-item label="审核备注" prop="">
                {{ viewData.remark }}
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button
                style="
                    min-width: 117px;
                    background: #1067e0;
                    font-size: 16px;
                    border-color: #1067e0;
                "
                size="mini"
                type="primary"
                @click="$emit('onUpdateDrawer', -1)"
                >取消</el-button
            >
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/car";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            id: "",
            viewData: {},
        };
    },
    components: {
        Pagination,
    },
    created() {},
    mounted() {},
    methods: {
        initFun(obj) {
            let that = this;
            if (obj.id) {
                // 编辑
                this.id = obj.id;
                fetch.detail({ id: this.id }).then((res) => {
                    that.viewData = res.result;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
